import { DateTime } from 'luxon'

export const tooltipHTML = (date, time, activityZoneOccupancyList) => {
    return (
        `<div class="occupancy-chartjs-custom-tooltip">
            <div class="occupancy-chartjs-custom-tooltip-header">
                ${date}
            </div>
            <div class="occupancy-chartjs-custom-tooltip-header">
                ${time}
            </div>` +
            activityZoneOccupancyList
                .map(({ activityZone, occupancy }) => {
                    return (
                        `<div class="occupancy-chartjs-custom-tooltip__activity-zone">
                            ${activityZone}
                        </div>
                        <div class="occupancy-chartjs-custom-tooltip__occupancy">
                            ${occupancy} Occupancy
                        </div>`
                    )
                })
                .join('') +
        '</div>'
    )
}

const OccupancyGraphTooltip = (canvas, timezone, activityZones) => tooltipModel => {
    let tooltipEl = document.getElementById('occupancy-chartjs-tooltip')
    if (!tooltipEl) {
        tooltipEl = document.createElement('div')
        tooltipEl.id = 'occupancy-chartjs-tooltip'
        canvas.insertAdjacentElement('afterend', tooltipEl)
    }
    tooltipEl.style.zIndex = 10
    tooltipEl.style.position = 'absolute'
    tooltipEl.style.left = tooltipModel.caretX + 'px'

    tooltipEl.style.top = (tooltipModel.caretY - 50) + 'px'

    let timestampAtCursor = tooltipModel.title ? tooltipModel.title[0] : ''
    if (tooltipModel && tooltipModel.dataPoints && activityZones.length && timestampAtCursor) {
        const thresholdValue = tooltipModel.dataPoints.slice(-1)[0].value
        const occupancyLevelsAtCursor = tooltipModel.dataPoints.slice(0, -1).map(d => Number(d.value) > Number(thresholdValue) ? 'Elevated' : 'Normal')
        const activityZoneOccupancyLevels = activityZones.map((az, i) => {
            return { activityZone: az, occupancy: occupancyLevelsAtCursor[i] }
        })
        timestampAtCursor = DateTime.fromISO(timestampAtCursor).setZone(timezone)
        const date = timestampAtCursor.toFormat('LLL d, yyyy')
        const time = timestampAtCursor.toFormat('h:mm a (ZZZZ)')
        tooltipEl.style.opacity = 1
        tooltipEl.innerHTML = tooltipHTML(date, time, activityZoneOccupancyLevels)
    } else tooltipEl.style.opacity = 0
  }

export default OccupancyGraphTooltip
